
<template lang="pug">
QSelectMod.select-store(
  v-bind="$attrs"
  :value="value_"
  :options="options"
  popup-max-height="36rem"
  v-on="listeners"
)
</template>

<script>
import {mapAuto} from 'helpers/vuex-bind'

import QSelectMod from 'components/QSelectMod'

export default {
  components: {QSelectMod},

  props: {
    storeCode: {required: true},
    floorCode: {required: true},
  },

  computed: {
    ...mapAuto(['stores']),

    listeners() {
      return {
        ...this.$listeners,
        input: value => {this.change(value)},
        change: () => {},
      }
    },

    value_() {
      return this.storeCode + '/' + this.floorCode
    },

    options() {
      return this.stores.map(store => ({
        value: store.store_code + '/' + store.floor_code,
        label: store.label,
      }))
    },

    validValue() {
      let store = this.stores.find(store =>
        store.store_code == this.storeCode &&
        store.floor_code == this.floorCode
      )
      if(store == null && this.stores.length !== 0) {
        store = this.stores[0]
      }
      return store == null
        ? null
        : store.store_code + '/' + store.floor_code
    },
  },

  watch: {
    validValue: {
      immediate: true,
      handler(value) {
        if(value != null && value != this.value_)  {
          this.change(value)
        }
      },
    },
  },

  methods: {
    change(value) {
      const [storeCode, floorCode] = value.split('/')
      this.$emit('input',  storeCode, floorCode)
      this.$emit('change', storeCode, floorCode)
    },
  },
}
</script>

<style lang="sass">
.select-store
  width: 12rem
</style>
